<template>
  <v-list dense>
    <template v-for="item in items">
      <v-list-item
        :key="item.name"
        v-if="(item.hideChildrenInMenu || !item.children) && !item.hidden"
        link
        :to="item.path"
      >
        <v-list-item-icon>
          <v-icon v-text="item.meta.icon" />
        </v-list-item-icon>

        <v-list-item-title
          class="item-title font-weight-bold"
          v-text="$t(item.meta.title)"
        />
      </v-list-item>

      <v-list-group
        :key="item.name"
        prepend-icon="fas fa-sitemap"
        no-action
        v-else-if="item.name == 'Story mode'"
      >
        <template v-slot:activator>
          <v-list-item-title
            class="item-title font-weight-bold"
            v-text="`シーズン一覧`"
          />
        </template>
        <template v-for="(season, idxSeason) in menuList">
          <v-list :key="season.name" dense>
            <!-- List season -->
            <v-list-group class="list-season">
              <template v-slot:activator>
                <v-list-item-title
                  class="text-capitalize subtitle-2"
                  v-text="season.name"
                />
              </template>
              <v-list-item
                link
                class="width-10"
                value="General"
                :class="generalSeason(season.Id)"
                style="padding-left: 60px"
                :to="{
                  name: 'List General OF Season',
                  params: { season: season.Id },
                  query: {
                    season: season.name,
                    questionNo: `シーズン${idxSeason + 1}まとめ`,
                  },
                }"
              >
                <v-list-item-title class="text-capitalize subtitle-2"
                  >シーズン{{ idxSeason + 1 }}まとめ</v-list-item-title
                >
              </v-list-item>
              <template v-for="(chapter) in season.chapters">
                <!-- List chapter -->
                <div :key="chapter.name">
                  <v-list dense>
                    <v-list-group class="list-chapter">
                      <template v-slot:activator>
                        <v-list-item-title
                          class="text-capitalize subtitle-2"
                          v-text="chapter.name"
                        />
                      </template>
                      <template v-for="section in chapter.sections">
                        <v-list-item
                          :key="section.name"
                          link
                          class="item-section"
                          :class="detailSection(section.Id)"
                          :to="{
                            name: 'Detail Section',
                            params: {
                              season: season.Id,
                              section: section.Id,
                              chapter: chapter.Id,
                            },
                            query: {
                              season: season.name,
                              chapter: chapter.name,
                              section: section.name,
                            },
                          }"
                        >
                          <v-list-item-title
                            class="text-capitalize subtitle-2"
                            v-text="section.name"
                          />
                        </v-list-item>
                      </template>
                      <v-list-item
                        link
                        class="width-10"
                        style="padding-left: 80px"
                        :class="generalChapter(chapter.Id)"
                        :to="{
                          name: 'List General OF Chapter',
                          params: { chapter: chapter.Id },
                          query: {
                            season: season.name,
                            chapter: chapter.name,
                            questionNo: ` エピソード${chapter.name.split('エピソード ')[1]}まとめ`,
                          },
                        }"
                      >
                        <v-list-item-title class="text-capitalize subtitle-2">
                          エピソード{{
                            chapter.name.split("エピソード ")[1]
                          }}まとめ</v-list-item-title
                        >
                      </v-list-item>
                    </v-list-group>
                  </v-list>
                </div>
              </template>
            </v-list-group>
          </v-list>
        </template>
      </v-list-group>
      <v-list-group
        :prepend-icon="item.meta.icon ? item.meta.icon : ''"
        :key="item.name"
        no-action
        v-else-if="(!item.hideChildrenInMenu || item.children) && !item.hidden"
      >
        <template v-slot:activator>
          <v-list-item-title
            class="item-title font-weight-bold"
            :to="item.path"
            v-text="$t(item.meta.title)"
          />
        </template>
        <template v-for="itemInChildren in item.children">
          <v-list-item
            :key="itemInChildren.name"
            v-if="!itemInChildren.hidden"
            link
            :to="itemInChildren.path"
          >
            <v-list-item-title
              class="item-title font-weight-bold"
              v-text="$t(itemInChildren.meta.title)"
            />
            <v-list-item-icon v-if="itemInChildren.meta.icon">
              <v-icon v-text="itemInChildren.meta.icon" />
            </v-list-item-icon>
          </v-list-item>
        </template>
      </v-list-group>
    </template>
  </v-list>
</template>

<script>
export default {
  name: "Sidebar",
  props: {
    items: {
      type: Array,
    },
  },
  data() {
    return {
      model: "General",
      menuList: this.$ls.get("Menu_List"),
    };
  },
  methods: {
    generalSeason(season) {
      const { name } = this.$route;
      if (season != this.$route.params.season) return "";
      if (
        name == "List General OF Season" ||
        name == "Create General OF Season" ||
        name == "Update General OF Season" ||
        name == "Detail General OF Season"
      ) {
        return "v-list-item--active";
      }
      return "";
    },
    generalChapter(chapter) {
      const { name } = this.$route;
      if (chapter != this.$route.params.chapter) return "";
      if (
        name == "List General OF Chapter" ||
        name == "Create General OF Chapter" ||
        name == "Update General OF Chapter" ||
        name == "Detail General OF Chapter"
      ) {
        return "v-list-item--active";
      }
      return "";
    },
    detailSection(section) {
      const { name } = this.$route;
      if (section != this.$route.params.section) return "";
      if (
        name == "Detail Section" ||
        name == "Add Grammar OF Section" ||
        name == "Update Grammar OF Section" ||
        name == "Add Expression OF Section" ||
        name == "Update Expression OF Section" ||
        name == "Add Expression OF Section" ||
        name == "List General OF Section" ||
        name == "Create General OF Section" ||
        name == "Update General OF Section" ||
        name == "Detail General OF Section" ||
        name == "Detail Skit"
      ) {
        return "v-list-item--active";
      }
      return "";
    },
  },
};
</script>

<style scoped>
.v-list-item--link:before {
  background-color: white;
}

.v-list .v-list-item--active {
  color: #42b983;
}
.item-title {
  line-height: 1.5rem !important;
}
::v-deep
  .list-season
  > .v-list-group__header.v-list-item.v-list-item--link.theme--light {
  padding-left: 50px;
}
::v-deep
  .list-chapter
  > .v-list-group__header.v-list-item.v-list-item--link.theme--light {
  padding-left: 60px;
}
::v-deep .item-section.v-list-item.v-list-item--link.theme--light {
  padding-left: 80px;
}
::v-deep
  .v-application--is-ltr
  .v-list-group--no-action
  > .v-list-group__items
  > .v-list-item {
  padding-left: 50px;
}
</style>
